module.exports = __webpack_public_path__ + "static/media/digiFolio.51dfdd8b.png";